<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="user"
                    :rules="{ required: true }"
                    prepend-icon="ni ni-single-02"
                    placeholder="Usuario"
                    v-model="model.user"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                    >
                      Sign in</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "@/directives/axios.js";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  data() {
    return {
      token: undefined,
      model: {
        user: "",
        password: "",
      },
    };
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      if (this.$cookies.isKey("catecumen_token")) {
        this.$router.push({ name: "dashboard" });
      }
    },
    onSubmit() {
      loader.open();
      axios({
        method: "POST",
        url: "/login",
        data: {
          email: this.model.user,
          password: this.model.password,
        },
      })
        .then((value) => {
          this.token = value.data.token;
          if (!this.$cookies.isKey("catecumen_token") && this.token) {
            this.$cookies.set("catecumen_token", this.token, 60 * 60 * 1);
            this.$store.commit("resetValues");
          }
          this.checkLogin();
          loader.close();
        })
        .catch((error) => {
          loader.close();
          if (error.response && error.response.data) {
            alert(
              error.response.data.message +
                (error.response.data.intentos_restantes
                  ? ", numero de intentos restantes: " +
                    error.response.data.intentos_restantes
                  : "")
            );
          } else {
            alert("Se ha producido un error desconocido, intentelo mas tarde o hable con el administrador.");
          }
        });
    },
  },
};
</script>
